import React from "react";
import { FaArrowRight } from "react-icons/fa";
import "./CTA.css";

const CTA = () => {
  return (
    <section className="uiqw-oglitz-cta-dark-root">
      <div className="uiqw-oglitz-cta-dark-wrapper">
        {/* CONTENT */}
        <div className="uiqw-oglitz-cta-dark-content">
          <span className="uiqw-oglitz-cta-dark-badge">Start Your Project</span>

          <h2 className="uiqw-oglitz-cta-dark-title">
            Ready to Build a <span>High-Impact Digital Product?</span>
          </h2>

          <p className="uiqw-oglitz-cta-dark-desc">
            Partner with a global software development team trusted by
            businesses across <strong>UAE, India, and worldwide</strong>. We
            design and build scalable, secure, and premium digital solutions.
          </p>

          <div className="uiqw-oglitz-cta-dark-actions">
            <a href="/start-project" className="uiqw-oglitz-cta-dark-primary">
              Start a Project <FaArrowRight />
            </a>

            <a href="/contact" className="uiqw-oglitz-cta-dark-secondary">
              Talk to Experts
            </a>
          </div>
        </div>

        {/* VISUAL ACCENT */}
        <div className="uiqw-oglitz-cta-dark-visual">
          <div className="uiqw-oglitz-cta-dark-glow" />
        </div>
      </div>
    </section>
  );
};

export default CTA;
